import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';

import { CopySourceAdapter, commonCopySourceAdapts } from './copysource.adapter';
import { CopyActivity } from 'app/model/pipeline/copy.activity';
import { JiraCopySource } from 'app/model/pipeline/copysource/jira.copysource';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(JiraCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        query: '*'
    }
})
export class JiraCopySourceAdapter extends CopySourceAdapter<JiraCopySource, Model.JiraSource> {
    protected override async _toResource(copySource: JiraCopySource): Promise<Model.JiraSource> {
        return this._toTabularResource(copySource, Metamodel.modelFor(JiraCopySource).name);
    }

    protected override async _toModel(resource: Model.JiraSource, copyActivity: CopyActivity): Promise<JiraCopySource> {
        return this._toTabularModel(resource, copyActivity, JiraCopySource.MODEL);
    }
}
